import { useEffect, useState } from 'react'
import type { AgentInstructions } from '@domain/agent'
import { useFinanceRepositories } from '@ui/finance/finance-context'

/**
 * O contexto de agente da casa, pela porta. Três estados pelo mesmo motivo de
 * `useMembers`: contexto vazio e contexto não carregado dizem coisas diferentes
 * — e aqui a diferença é grande, porque a tela é um formulário. Renderizar
 * campos vazios enquanto a leitura está no ar convidaria a pessoa a digitar por
 * cima do que ainda vai chegar.
 */
export type InstructionsState =
  | { status: 'loading' }
  | { status: 'loaded'; instructions: AgentInstructions }
  | { status: 'failed' }

export function useAgentInstructions(): InstructionsState {
  const { agentInstructionsRepository } = useFinanceRepositories()
  const [state, setState] = useState<InstructionsState>({ status: 'loading' })

  useEffect(() => {
    let live = true
    void agentInstructionsRepository
      .load()
      .then((instructions) => {
        if (live) setState({ status: 'loaded', instructions })
      })
      .catch((error: unknown) => {
        console.error('useAgentInstructions: load falhou', error)
        if (live) setState({ status: 'failed' })
      })
    return () => {
      live = false
    }
  }, [agentInstructionsRepository])

  return state
}
